export default "__VITE_ASSET__CLgRNkFc__"